<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('regulation-policies')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">
        Add Regulation Policies & Papers
      </h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <p class="mb-1">Title</p>
        <base-input
          alternative
          class="mb-3"
          name="Title"
          :rules="{ required: true }"
          placeholder="Write Title here"
          v-model="title"
        >
        </base-input>
        <p class="mb-1">Description</p>
        <base-input
          alternative
          class="mb-3"
          name="description"
          :rules="{ required: true }"
          placeholder="Write Description here"
          v-model="description"
          :maxlength="500"
          @input="limitDescription"
        >
        </base-input>
        <p>
          only this much Characters are allowed {{ description.length }} / 500
        </p>
        <br />
        <!-- </base-input> -->
        <!-- <p>Attach your files</p>
        <b-form-file
          v-model="file1"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
          accept=".pdf"
          @input="validateFile"
        ></b-form-file>

        <b-form-group
          label="Friends updates image (Max size 5MB and Dimensions should H-700, W-900)"
        >
          <FileUploader
            v-show="!coverImage"
            :image="image"
            :onSuccess="handleSuccess"
          />
          <Cropper
            class="cropper"
            :src="image"
            v-if="coverImage != ''"
            @change="handleCropperChange"
            ref="cropper"
            :stencil-props="{
              aspectRatio: 2 / 1,
            }"
          />

          <div class="flex cursor-pointer items-center my-2" v-if="image">
            <base-button type="danger" class="px-8" @click="handleRemove">
              Remove image
            </base-button>
          </div>
          <span v-if="imageErr" class="flex justify-center small text-danger">{{
            msg.image
          }}</span>
          <img v-if="image" :src="cropperImg" ref="cover" />
        </b-form-group>
        <p>Redirect Link</p>
        <base-input
          class="mb-3"
          name="Link"
          placeholder="Enter Redirection Link "
          v-model="link"
        >
        </base-input> -->
        <!-- **Radio Buttons for Selection** -->
        <b-form-group label="Choose Upload Type" class="lg:pb-2">
          <b-form-radio-group v-model="uploadType" class="d-flex">
            <b-form-radio value="file" class="mr-3">Upload File</b-form-radio>
            <b-form-radio value="link">Enter Link</b-form-radio>
          </b-form-radio-group>
        </b-form-group>

        <div v-if="uploadType === 'file'">
          <p>Attach your files</p>
          <b-form-file
            v-model="file1"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            accept=".pdf"
            @input="validateFile"
          ></b-form-file>
        </div>

        <div v-if="uploadType === 'link'">
          <p>Redirect Link ( Prefix this link with' https:// ' )</p>
          <base-input
            class="mb-3"
            name="Link"
            placeholder="https://www.example.com"
            v-model="link"
          />
        </div>

        <b-form-group
          label="Upload Image (Max size 5MB, Dimensions H-700 W-900)"
        >
          <FileUploader
            v-show="!coverImage"
            :image="image"
            :onSuccess="handleSuccess"
          />
          <Cropper
            class="cropper"
            :src="image"
            v-if="coverImage !== ''"
            @change="handleCropperChange"
            ref="cropper"
            :stencil-props="{ aspectRatio: 2 / 1 }"
          />
          <div class="flex cursor-pointer items-center my-2" v-if="image">
            <base-button type="danger" class="px-8" @click="handleRemove">
              Remove image
            </base-button>
          </div>
          <span v-if="imageErr" class="flex justify-center small text-danger">{{
            msg.image
          }}</span>
          <img v-if="image" :src="cropperImg" ref="cover" />
        </b-form-group>
        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Create</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
// import { mapState } from "vuex";
import "vue-advanced-cropper/dist/style.css";
import { Cropper } from "vue-advanced-cropper";

export default {
  components: {
    FileUploader,
    quillEditor,
    Cropper,
  },
  data() {
    return {
      title: "",
      link: "",
      image: "",
      coverImage: "",
      cropperImg: "",
      file1: null,
      fileError: false,
      fileErrorMessage: "",
      coverImage: null,
      description: "",
      imageErr: false,
      editorOption: {
        theme: "snow",
      },
      uploadType: "file",
    };
  },
  methods: {
    limitDescription(event) {
      if (this.description.length > 500) {
        this.description = this.description.substring(0, 500);
      }
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    handleCropperChange(img) {
      // console.log(img);
      this.cropperImg = this.$refs.cropper.getResult().canvas.toDataURL();
      this.coverImage = this.dataURLtoFile(img.canvas.toDataURL(), "image.png");
    },
    // handleSuccess(image) {
    //   console.log(image);

    //   this.imageErr = false;
    //   if (!image.type.includes("image")) {
    //     this.imageErr = true;
    //     this.msg.image = "Upload Image Only";
    //   } else {
    //     this.imageErr = false;
    //     let mByte = 5 * 1048576;
    //     if (image.size > mByte) {
    //       this.$swal.fire({
    //         title: "File size exceeds the allowed limit!",
    //         text: "Please ensure that the file size does not exceed 5MB",
    //         html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
    //         confirmButtonText: "Okay",
    //         icon: "warning",
    //         confirmButtonColor: "#830c81",
    //         showCancelButton: false,
    //       });
    //       return;
    //     }
    //     this.coverImage = image;
    //     this.readerData(image);
    //   }
    // },
    handleSuccess(image) {
      console.log(image);

      this.imageErr = false;

      if (!image.type.startsWith("image/")) {
        this.$swal.fire({
          title: "Invalid File",
          text: "Please upload an image file only!",
          // html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          icon: "error",
          confirmButtonColor: "#830c81",
          confirmButtonText: "Okay",
        });
        return;
      }

      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          text: "Please ensure that the file size does not exceed 5MB",
          icon: "warning",
          confirmButtonColor: "#830c81",
          confirmButtonText: "Okay",
        });
        return;
      }

      this.coverImage = image;
      this.readerData(image);
    },

    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    validateFile(file) {
      this.fileError = false;
      this.fileErrorMessage = "";
      if (!file) {
        this.file1 = null;
        return;
      }
      if (!file.type.includes("pdf")) {
        this.fileError = true;
        this.fileErrorMessage = "Only PDF files are allowed!";
        this.file1 = null;
        return;
      }

      const maxSize = 10 * 1024 * 1024;
      if (file.size > maxSize) {
        this.fileError = true;
        this.fileErrorMessage =
          "File size exceeds 10MB! Please upload a smaller file.";
        this.file1 = null;
        return;
      }

      this.file1 = file;
    },

    async onSubmit() {
      let Regex = /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z0-9-]{2,6}(\/[^\s]*)?$/i;
      if (this.uploadType === "link" && !Regex.test(this.link.trim())) {
        this.$notify.error({
          message: "Please Enter Valid URL",
          position: "top-right",
        });
        return false;
      } else if (!this.coverImage) {
        this.$notify.error({
          message: "Please Select Image",
          position: "top-right",
        });
        return;
      }

      if (this.fileError) {
        this.$swal.fire({
          title: "Invalid File",
          text: this.fileErrorMessage,
          icon: "warning",
          confirmButtonColor: "#830c81",
          confirmButtonText: "Okay",
        });
        return;
      }

      if (!this.file1 && !this.link) {
        this.$swal.fire({
          title: "File or Link field is Missing",
          text: "Please upload a valid PDF file or Add Link.",
          icon: "warning",
          confirmButtonColor: "#830c81",
          confirmButtonText: "Okay",
        });
        return;
      }
      let FormData = require("form-data");
      let data = new FormData();

      data.append("title", this.title);
      data.append("description", this.description.trim());

      // if (this.link.trim()) {
      //   data.append("link", this.link);
      // }
      // data.append("file", this.file1);
      // data.append("uploadType", this.uploadType);
      data.append("uploadType", this.uploadType);
      if (this.uploadType === "file" && this.file1) {
        data.append("file", this.file1);
      }
      if (this.uploadType === "link" && this.link.trim()) {
        data.append("link", this.link.trim());
      }
      data.append("image", this.coverImage);
      let loader = this.$loading();

      try {
        const newsdata = await this.$store.dispatch(
          "regulationPolicy/createRegulations",
          data
        );
        // console.log(newsdata, "555");

        if (newsdata.code == 200) {
          this.$router.push({ name: "regulation-policies" });
          this.$swal.fire({
            text: "Data Successfully Added",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
        loader.close();
      } catch (error) {
        if (error.response.status) {
          this.$swal.fire({
            title: "Error",

            text: error.response.data.message,
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        }
      }
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
